/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { Wrapper } from '../components/wrapper';
import PreTitle from '../components/pretitle';
import Title from '../components/title';
import Paragraph from '../components/paragraph';
import Visual from '../components/visual';

const OneVisualLayout = ({
  section,
  subSection,
  title,
  paragraph1,
  paragraph2,
  visual,
  visualProps = {},
}) => (
  <Wrapper>
    <PreTitle>{section}{subSection ? ` | ${subSection}` : ''}</PreTitle>
    <Title>{title}</Title>
    <Paragraph>
      {paragraph1}
    </Paragraph>
    <Visual data={visual} {...visualProps} />
    {paragraph2 && <Paragraph>
      {paragraph2}
    </Paragraph>}
  </Wrapper>
);

export default OneVisualLayout;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/layouts/one-visual.js